<template>
  <div>
    <hr class="horizontal" />
    <div class="faq">
      <i class="material-icons faq-left">
        help_outline
      </i>

      <span class="faq-right">
        Frequently Asked Questions
      </span>
    </div>

    <div>
      <button type="button" class="collapsible" @click="expandPanel(1)">
        <div>
          <div class="left"><b>What is a proxy holder?</b></div>
          <div class="right">
            <i v-if="!display.panelOne" class="material-icons expansion-icon">
              expand_more
            </i>
            <i v-else class="material-icons expansion-icon">
              expand_less
            </i>
          </div>
        </div>
      </button>
      <div v-if="display.panelOne" class="content">
        <!-- Limited proxy (meeting has questions) -->
        <div v-if="hasQuestions">
          <p v-if="isOntarioProxy">
            A proxy holder attends the meeting and votes in your place,
            according to the votes you submit on this form.
          </p>
          <p v-else>
            A proxy holder attends the meeting and votes in your place,
            according to the votes you submit on this form. No one will be able
            to alter your vote.
          </p>
        </div>
        <!-- General proxy (meeting has no questions) -->
        <div v-else>
          <p>
            A proxy holder attends the meeting and votes in your place.
          </p>
        </div>
      </div>
    </div>

    <div>
      <button type="button" class="collapsible" @click="expandPanel(2)">
        <div>
          <div class="left"><b>Who should I choose?</b></div>
          <div class="right">
            <i v-if="!display.panelTwo" class="material-icons expansion-icon">
              expand_more
            </i>
            <i v-else class="material-icons expansion-icon">
              expand_less
            </i>
          </div>
        </div>
      </button>
      <div v-if="display.panelTwo" class="content">
        <ul class="expansion-list">
          <li>
            Someone who will be present at the meeting
          </li>
          <li>The President or Secretary of the Corporation</li>
        </ul>

        <p v-if="!isFallbackHolderDisabled">
          <span v-if="isOntarioProxy">
            If the person you choose fails to attend the meeting, then your
            proxy will "fallback" to a backup proxy holder to ensure your vote
            is counted.
          </span>
          <span v-else>
            If the person you choose can't attend the meeting after all, the
            President or Secretary of the Corporation will be appointed as a
            fallback
          </span>
        </p>
      </div>
    </div>

    <div v-if="!isFallbackHolderDisabled">
      <button type="button" class="collapsible" @click="expandPanel(3)">
        <div>
          <div class="left">
            <b>Why must a fallback proxy holder be appointed?</b>
          </div>
          <div class="right">
            <i v-if="!display.panelThree" class="material-icons expansion-icon">
              expand_more
            </i>
            <i v-else class="material-icons expansion-icon">
              expand_less
            </i>
          </div>
        </div>
      </button>
      <div v-if="display.panelThree" class="content">
        <p>
          In case your preferred proxy holder is unable to attend the meeting, a
          fallback holder must be appointed to ensure your vote counts.

          <span v-if="isOntarioProxy">
            Otherwise, if none of your proxy holders are in attendance then your
            proxy becomes invalid and your vote cannot be counted.
          </span>
        </p>
      </div>
    </div>

    <div v-if="!isFallbackHolderDisabled && isOntarioProxy">
      <button type="button" class="collapsible" @click="expandPanel(4)">
        <div>
          <div class="left">
            <b>
              Can my proxy holder change my vote?
            </b>
          </div>
          <div class="right">
            <i v-if="!display.panelFour" class="material-icons expansion-icon">
              expand_more
            </i>
            <i v-else class="material-icons expansion-icon">
              expand_less
            </i>
          </div>
        </div>
      </button>
      <div v-if="display.panelFour" class="content">
        <p>
          No, your proxy holder cannot alter your vote. It's important to note
          that the proxy holder, whether it be your primary proxy holder or the
          fallback, as the case may be, must legally vote your proxy in
          accordance with your instructions.
        </p>
      </div>
    </div>

    <div v-if="!isFallbackHolderDisabled">
      <button type="button" class="collapsible" @click="expandPanel(5)">
        <div>
          <div class="left">
            <b>
              What if I don't wish for {{ fallbackHoldersText }} to be appointed
              as a fallback?
            </b>
          </div>
          <div class="right">
            <i v-if="!display.panelFive" class="material-icons expansion-icon">
              expand_more
            </i>
            <i v-else class="material-icons expansion-icon">
              expand_less
            </i>
          </div>
        </div>
      </button>
      <div v-if="display.panelFive" class="content">
        <p>
          You may submit a paper proxy to your organization instead of using
          this online tool.
        </p>
        <p v-if="isOntarioProxy">
          Please refer to your Notice of Meeting package or visit the
          <a
            href="https://www.condoauthorityontario.ca/resources/condominium-forms/"
            target="_new"
          >
            Condominium Authority of Ontario Website
          </a>
          to download the forms.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  components: {},
  props: {
    isFallbackHolderDisabled: {
      type: Boolean,
      default: false
    },
    fallbackHoldersText: {
      type: String,
      default: ''
    },
    // If bill-106, display alternative content for the FAQ
    isOntarioProxy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('questions', ['questions']),
    hasQuestions() {
      return this.questions.length > 0;
    }
  },
  data() {
    return {
      display: {
        panelOne: false,
        panelTwo: false,
        panelThree: false,
        panelFour: false,
        panelFive: false
      }
    };
  },
  methods: {
    expandPanel(num) {
      if (num === 1) {
        this.display.panelOne = !this.display.panelOne;
      }
      if (num === 2) {
        this.display.panelTwo = !this.display.panelTwo;
      }
      if (num === 3) {
        this.display.panelThree = !this.display.panelThree;
      }
      if (num === 4) {
        this.display.panelFour = !this.display.panelFour;
      }
      if (num === 5) {
        this.display.panelFive = !this.display.panelFive;
      }
    }
  }
};
</script>

<style scoped>
.horizontal {
  margin: 35px 0;
}

.faq {
  color: rgb(63, 81, 181);
}

.faq-left {
  display: inline-block;
  vertical-align: -5px;
}

.faq-right {
  display: inline-block;
  vertical-align: 2px;
  padding-left: 8px;
}

.collapsible {
  background-color: #dedede;
  color: #444;
  cursor: pointer;
  padding: 18px;
  margin-top: 10px;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
}

.left {
  float: left;
}

.right {
  text-align: right;
}

.expansion-icon:hover {
  background-color: #ccc;
  border-radius: 50%;
}

.content {
  padding: 10px 18px 0;
  overflow: hidden;
  background-color: #ffffff;
}

.expansion-list {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FrequentlyAskedQuestions.vue